// extracted by mini-css-extract-plugin
module.exports = {"pdfPagination":"_3RwDwY1MWVOnuUqCjMJKLC","pdfPaginationButton":"_3n2OFjFI0zJrIeuDa4xAXQ","pdfPaginationPageNumber":"_2K4KSrv4WRW-VUl-ufGxxt"};